import { gql } from '@apollo/client'
import { MUTATION_STATE } from 'api/fragments'

const PAYLOAD_TYPE = 'DestroyVoohCampaignPayload'

export const DESTROY_VOOH_CAMPAIGN = gql`
  ${MUTATION_STATE(PAYLOAD_TYPE)}
  mutation destroyVoohCampaign($id: ID!) {
    destroyVoohCampaign(input: { id: $id }) {
      ...MutationState${PAYLOAD_TYPE}Fields
    }
  }
`
